import React from 'react'
import "./Font.scss";

const Font = () => {
  return (
    <div id="div">
    <h1><span>R</span><span>e</span><span>d</span><span>u</span><span>x</span></h1>
    </div>
  )
}

export default Font